<template lang="html">
<div class="login-container">
  <b-container fluid>
    <b-row class="align-items-center">
      <b-col
        cols="12" md="6" lg="7"
        class="fullscreen-md d-flex justify-content-center align-items-center overlay gradient gradient-59 alpha-5 image-background cover"
        style="background-image:url(https://picsum.photos/1920/1200/?image=856&gravity=south)"
      >
        <div class="content">
          <h2 class="display-4 display-md-3 color-1 mt-4 mt-md-0 mb-7">Welcome to
            <span class="bold d-block logo">Unstitched</span>
          </h2>
        </div>
      </b-col>

      <b-col col md="5" lg="4" class="mx-auto">
        <div class="login-form mt-5 mt-md-0">
          <span class="title-text">UNSTITCHED</span>
          <img src="img/logo.png" class="logo img-responsive mb-4 mb-md-6" alt="">
          <h1 class="color-9 bold1">Login</h1>
          <p class="color-2 mt-0 mb-4 mb-md-6">Don't have an account yet?
            <a href="register.html" class="color-7 bold">Create it here</a>
          </p>
          <form class="cozy" action="srv/login.php" data-validate-on="submit" @submit.prevent="dispatchLogin" novalidate>
            <label class="control-label bold small text-uppercase color-2">E-mail</label>
            <div class="form-group has-icon">
              <input type="text" id="login_username" name="Login[username]" class="form-control form-control-rounded light" placeholder="Your e-mail" v-model="email" required>
              <i class="icon fas pe-7s-user"></i>
            </div>
            <label class="control-label bold small text-uppercase color-2">Password</label>
            <div class="form-group has-icon">
              <input type="password" id="login_password" name="Login[password]" class="form-control form-control-rounded light" placeholder="Your password" v-model="password" required>
              <i class="icon fas pe-7s-lock"></i>
            </div>
            <div class="form-group d-flex align-items-center justify-content-between">
              <a href="forgot.html" class="text-warning small">Forgot your password?</a>
              <div class="ajax-button">
                <div class="fas fa-check btn-status text-success success"></div>
                <div class="fas fa-times btn-status text-danger failed"></div>
                <button type="submit" class="btn btn-accent btn-rounded">
                  <span class="pe-va">Login</span>
                  <i class="fas pe-7s-angle-right pe-2x pe-va"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import { mapActions, mapGetters } from 'vuex';

export default {
  mounted () {
    this.setShowHeader(false);
  },

  beforeDestroy () {
    this.setShowHeader(true);
  },

  data () {
    return {
      email: '',
      password: ''
    }
  },

  computed: {
    ...mapGetters ([
      'loginError',
      'currentUser'
    ])
  },

  methods: {
    ...mapActions ([
      'handleLogin',
      'setShowHeader'
    ]),

    dispatchLogin () {
      const payload = this.constructPayload();

      this.handleLogin(payload);
      this.resetLocalState();
    },

    constructPayload () {
      return {
        'auth': {
          'email': this.email,
          'password': this.password
        }
      }
    },

    resetLocalState () {
      this.email = '';
      this.password = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

$font-dir: "~@/assets/fonts/";

@font-face {
  font-family: "Lombok";
  src: url("#{$font-dir}Lombok/Lombok.eot");
  src: url("#{$font-dir}Lombok/Lombok.eot?#iefix") format("embedded-opentype"),
       url("#{$font-dir}Lombok/Lombok.woff") format("woff"),
       url("#{$font-dir}Lombok/Lombok.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.logo {
  font-family: "Lombok";
  text-transform: uppercase;
}

.title-text {
  font-family: "Lombok";
  font-size: 28px;
  color: $primary-blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue